import type {ReactElement, ReactNode} from 'react';
import React, {useState} from 'react';
import {ErrorBoundary as ReactErrorBoundary} from 'react-error-boundary';
import {logClientError} from '@Libraries/log.library';
import {ErrorBoundaryFallbackContainer} from '@Components/error-boundary-fallback-container/error-boundary-fallback-container';

interface ErrorBoundryProps {
  children: ReactNode;
}

export function PosterEditorErrorBoundary({...props}: ErrorBoundryProps): ReactElement<any> {
  const [reload, setReload] = useState(false);

  const getFallbackUI = (): ReactElement<unknown, typeof React.Component> => {
    return <ErrorBoundaryFallbackContainer onReload={onReload} />;
  };

  const onReload = (): void => {
    setReload(!reload);
  };

  const onError = (e: Error): void => {
    void logClientError(e, {
      posterReduxData: {...window.PMW.redux.store.getState().posterEditor},
    });
  };

  return (
    <ReactErrorBoundary resetKeys={[reload]} fallback={getFallbackUI()} onError={onError}>
      {props.children}
    </ReactErrorBoundary>
  );
}
